module.exports = __webpack_public_path__ + "assets/img/wlhy.21a3143b.jpg";